import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';
import { SELECT_ITEM_DEFAULT } from 'config';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

export default class SelectCategory extends React.Component {
  static propTypes = {
    width: PropTypes.any,
    hideLabel: PropTypes.bool,
    fieldForm: PropTypes.shape({
      form: PropTypes.any,
      name: PropTypes.string,
      option: PropTypes.object,
    }),
    getCategory: PropTypes.func.isRequired,
  };

  state = {
    itemList: [SELECT_ITEM_DEFAULT],
  };

  componentDidMount = async () => {
    const res = await this.props.getCategory();
    if (res.success)
      this.setState({
        itemList: [
          SELECT_ITEM_DEFAULT,
          ...res.data.map((item) => {
            return { value: item._id, label: item.Name };
          }),
        ],
      });
  };

  render() {
    const { label, getFieldProps, name, initialValue } = this.props;
    const fieldProps = getFieldProps(name, { initialValue });

    const isHidden = {
      style: {
        display: this.props.hideLabel ? 'none' : '',
      },
    };

    return (
      <Container>
        <span {...isHidden}>{label}</span>
        {/* <Clearfix {...isHidden} width={8} /> */}
        <div style={{ flex: 1 }}>
          <Select
            isClearable
            placeholder='-- Select --'
            style={{ flex: 1 }}
            classNamePrefix='react-select-custom'
            options={this.state.itemList}
            {...fieldProps}
          />
        </div>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/select-category/index.js